"use strict";
exports.__esModule = true;
exports.addStyle = void 0;
function addStyle(css) {
    var head = document.head || document.getElementsByTagName('head')[0], style = document.createElement('style');
    style.appendChild(document.createTextNode(css));
    head.appendChild(style);
}
exports.addStyle = addStyle;
